export type TeacherPortalView = 'gradebook' | 'teacher';

const STORAGE_KEY = 'TeacherPortalView';

export function getTeacherPortalView(): TeacherPortalView | null {
  const value = sessionStorage.getItem(STORAGE_KEY);
  if (value === 'gradebook' || value === 'teacher') {
    return value;
  }
  return null;
}

export function setTeacherPortalView(view: TeacherPortalView): void {
  sessionStorage.setItem(STORAGE_KEY, view);
}

export function clearTeacherPortalView(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}

/** 当前班级同时拥有任课教师与班主任两种身份时为 true。 */
export function hasBothTeacherAndTa(identities: { identity: string }[]): boolean {
  const hasTeacher = identities.some((i) => i.identity === 'teacher');
  const hasTa = identities.some((i) => i.identity === 'ta');
  return hasTeacher && hasTa;
}
